import { NextResponse } from "next/server";
import { auth } from "@/auth";
import { getServerCart } from "@/app/panier/actions";
import { stripe } from "@/lib/stripe";
import { prisma } from "@/lib/prisma";

export async function POST() {
  try {
    const session = await auth();

    if (!session?.user?.id) {
      return NextResponse.json(
        { error: "Vous devez être connecté pour payer." },
        { status: 401 }
      );
    }

    const cart = await getServerCart();

    const user = await prisma.user.findUnique({
      where: { id: session.user.id },
      select: {
        phone: true,
        address: true,
        postalCode: true,
        city: true,
      },
    });

    if (!user?.phone || !user?.address || !user?.postalCode || !user?.city) {
      return NextResponse.json(
        { error: "PROFILE_INCOMPLETE" },
        { status: 400 }
      );
    }

    if (!cart || cart.items.length === 0) {
      return NextResponse.json(
        { error: "Votre panier est vide." },
        { status: 400 }
      );
    }

    const appUrl = process.env.NEXT_PUBLIC_APP_URL as string;

    if (!appUrl) {
      return NextResponse.json(
        { error: "NEXT_PUBLIC_APP_URL est manquante." },
        { status: 500 }
      );
    }

    const checkoutSession = await stripe.checkout.sessions.create({
      mode: "payment",
      success_url: `${appUrl}/panier/succes?session_id={CHECKOUT_SESSION_ID}`,
      cancel_url: `${appUrl}/panier?cancelled=1`,
      client_reference_id: cart.id,
      customer_email: session.user.email ?? undefined,
      shipping_address_collection: {
        allowed_countries: ["FR", "BE", "CH", "LU"],
      },
      phone_number_collection: {
        enabled: true,
      },
      metadata: {
        cartId: cart.id,
        userId: session.user.id,
      },
      line_items: cart.items.map((item) => ({
        quantity: item.quantity,
        price_data: {
          currency: "eur",
          product_data: {
            name: item.product.name,
            description:
              item.product.shortDescription ||
              "Laine teinte artisanalement à la main",
            images: item.product.images?.[0]?.imageUrl
              ? [item.product.images[0].imageUrl]
              : [],
          },
          unit_amount: Math.round(Number(item.product.price) * 100),
        },
      })),
    });

    return NextResponse.json({
      url: checkoutSession.url,
    });
  } catch (error) {
    console.error("Erreur checkout Stripe :", error);

    const message =
      error instanceof Error ? error.message : "Erreur Stripe";

    return NextResponse.json({ error: message }, { status: 500 });
  }
}